import { Authority } from 'platform/app/authority.constant';

export const ADMIN_PANEL = {
    name: 'Admin panel',
    path: '/admin-panel',
    icon: 'dm-cog',
    redirectTo: '/admin-panel/websites',
    requiresAuthority: Authority.ROLE_ADMIN_PANEL_VIEW_EDIT,
};
